import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { GeographyProvider } from '../contexts/GeographyContext';
import { Continent } from '../types/geography';

const CONTINENTS: Continent[] = [
  {
    name: 'Africa',
    view: { longitude: 20, latitude: 10, zoom: 2.5 },
    countries: ['Nigeria', 'Ghana', 'Kenya', 'South Africa', 'Egypt', 'Benin'],
  },
  {
    name: 'North America',
    view: { longitude: -100, latitude: 40, zoom: 2.5 },
    countries: ['United States', 'Canada', 'Mexico'],
  },
];

const ReportsPage: React.FC = () => {
  const reportTypes = [
    { name: 'Overview', href: '/reports/overview' },
    { name: 'Movement Security', href: '/reports/movement-security' },
    { name: 'Threat Analysis', href: '/reports/threat-analysis' },
    { name: 'Threat Exposure', href: '/reports/threat-exposure' },
    { name: 'Security Advice', href: '/reports/security-advice' },
    { name: 'Recommended Baseline Security Mitigation', href: '/reports/recommended-baseline-sra' },
    { name: 'Threat Map Reference', href: '/reports/threat-map-reference' },
  ];

  return (
    <GeographyProvider continents={CONTINENTS}>
      <div className="flex h-full">
        {/* Left Sidebar */}
        <aside className="w-64 flex-shrink-0 bg-gray-50 border-r border-gray-200">
          <div className="p-4">
            <h2 className="text-lg font-semibold text-gray-900">Reports Menu</h2>
            <nav className="mt-4">
              {/* Security Assessments Parent Header */}
              <div className="mb-2">
                <h3 className="px-3 py-2 text-sm font-semibold text-gray-900 uppercase tracking-wider">
                  Security Assessments
                </h3>
                {/* Child Report Types */}
                <ul className="mt-1 space-y-1">
                  {reportTypes.map((item) => (
                    <li key={item.name}>
                      <NavLink
                        to={item.href}
                        className={({ isActive }) =>
                          `block pl-6 pr-3 py-2 rounded-md text-sm font-medium ${
                            isActive
                              ? 'bg-gray-200 text-gray-900'
                              : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                          }`
                        }
                      >
                        {item.name}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Complete Threat Assessment - Separate */}
              <div className="mt-4 pt-4 border-t border-gray-200">
                <NavLink
                  to="/reports/complete-report"
                  className={({ isActive }) =>
                    `block px-3 py-2 rounded-md text-sm font-medium ${
                      isActive
                        ? 'bg-gray-200 text-gray-900'
                        : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                    }`
                  }
                >
                  Complete Threat Assessment
                </NavLink>
                
                <NavLink
                  to="/reports/security-plan"
                  className={({ isActive }) =>
                    `block px-3 py-2 rounded-md text-sm font-medium mt-1 ${
                      isActive
                        ? 'bg-gray-200 text-gray-900'
                        : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                    }`
                  }
                >
                  Security Plan
                </NavLink>
              </div>
            </nav>
          </div>
        </aside>

        {/* Main Content */}
        <main className="flex-1 p-6 bg-white">
          <Outlet />
        </main>
      </div>
    </GeographyProvider>
  );
};

export default ReportsPage;
